<template lang="html">
  <div class="productShare">
    <Header :openTarget="'webView/detail?url=' + encodeURIComponent(apppagebase + '/product?pid='  + pid)" />
    <div class="content">
      <div class="goodsDescribe">
        <img :src="productInfo.product_cover" alt="" class="goodsImg">
        <div class="goodsInfo">
          <p class="goodsTitle">{{productInfo.product_name}}</p>
          <p class="goodsData">
            <span class="goodsPrice" v-if="productInfo.reference_price">￥<span>{{productInfo.reference_price}}</span>参考价</span>
            <span class="goodsPrice" v-else>暂无参考价</span>
            <span class="goodsUnmber">{{productInfo.view_number}}人浏览</span>
          </p>
        </div>
      </div>
      <div class="enterpriseDescribe">
        <div class="enterpriseName">
          <div class="enterpriseImg">
            <img :src="productInfo.avatar" alt="" class="enterpriseHeadPortrait">
            <img src="@/assets/image/icon/mark.png" alt="" class="enterpriseMark">
            <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + productInfo.uid"/>
          </div>
          <p>{{productInfo.username}}</p>
        </div>
        <div class="enterpriseReleaseTime">
          发布于 {{productInfo.createtime}}
        </div>
      </div>

      <div v-html="productCon" class="productCon"></div>

      <div class="recommendedGoods" v-show="recommendProduct.length > 0">
        <p class="recommendedTitle">推荐产品</p>
        <div class="recommendedGoodsMod">
          <div v-for="a in recommendProduct.slice(0,2)" :key="a.id" class="recommendedGoodsList" @click="getRecommendedProductInfo(a.id)">
            <img :src="a.product_cover" alt="" class="recommendedGoodsImg">
            <p class="goodsTitle goodsTitlepro">{{a.product_name}}</p>
            <p class="goodsData">
              <span class="goodsPrice" v-if="a.reference_price">￥<span>{{a.reference_price}}</span>参考价</span>
              <span class="goodsPrice" v-else>暂无参考价</span>
              <span class="goodsUnmber">{{a.view_number}}人浏览</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="callAppIcon" v-show="callApp">
      <img src="../../assets/image/icon/download.png" alt="">
      <WxOpenTag ref="wxopentag" :extinfo="'webView/detail?url=' + encodeURIComponent(apppagebase + '/product?pid='  + pid)"/>
    </div>
  </div>
</template>

<script>
  import Header from '@/components/HeadModule'
  import utils from '@/utils/utils.js';
  import WxShare from '@/utils/wxshare';
  import WxOpenTag from '@/components/WxOpenTag'
  import {apppagebase} from '@/utils/http'

  export default {
    data() {
      return {
        pid: this.$route.query.pid || '',
        productInfo: {},
        productCon: '',
        recommendProduct: [],
        apppagebase: apppagebase,
        callApp: false,
      }
    },

    components: {
      Header,
      WxOpenTag,
    },

    mounted() {
      this.getWx = new WxShare();
      this.init();
      window.addEventListener('scroll', this.handleScroll)
    },

    methods: {
      init() {
        this.getProductInfo();
      },

      getProductInfo() {
        this.$http({
          url: '/product/productDetail',
          method: 'get',
          params: {
            product_id: this.pid,
          }
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.productInfo = data.product_info;
            this.recommendProduct = data.recommend_product;

            this.getWx.share({
              title: this.productInfo.product_name,
              desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
              link: window.location.href,
              imgUrl: this.productInfo.product_cover,
            });

            this.productCon = utils.checkTopicLink(this.productInfo.content)
            this.$nextTick(() => {
              let $links = document.querySelectorAll('.urlMod')
              $links.forEach(item => {
                item.addEventListener('click', e => {
                  let target = e.currentTarget
                  if (target.classList.contains('urlMod')) {
                    let reg = /^(http|https):\/\/\S*/;
                    if(reg.test(target.dataset.href)){
                      location.href = target.dataset.href
                    }
                  }
                })
              })
            })
          }
        })
      },
      
      getRecommendedProductInfo(id){
        this.pid = id;
        this.getProductInfo();
      },
      
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 500) {
          this.callApp = true;
        } else {
          this.callApp = false;
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  .goods {
    background-color: #F7F8F8;
  }

  .content {}

  .goodsDescribe {
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 1.6rem 1.5rem;
    display: flex;
    align-items: center;
    border-bottom: 0.05rem solid #C0C4CC;
  }

  .goodsImg {
    width: 8rem;
    height: 8rem;
    object-fit: cover;
    border-radius: .5rem;
  }

  .goodsInfo {
    margin-left: 1.2rem;
    width: 74%;
    height: 8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .goodsTitle {
    font-size: 1.4rem;
    font-weight: 600;
    color: #1D2023;
    height: 4rem;
    line-height: 2rem;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .goodsData {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    height: 21px;
  }

  .goodsPrice {
    color: #F7443F;
    font-size: 1rem;
    line-height: 1rem;
  }

  .goodsPrice span {
    font-size: 1.8rem;
    line-height: 1.8rem;
  }

  .goodsUnmber {
    font-size: 1.2rem;
    line-height: 1.2rem;
    color: #C0C4CC;
  }

  .enterpriseDescribe {
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 1.5rem;
    height: 4.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .enterpriseName {
    display: flex;
    align-items: center;
    color: #3F454B;
    font-size: 1.2rem;
  }

  .enterpriseName p {
    margin-left: 1rem;
  }

  .enterpriseImg {
    position: relative;
  }

  .enterpriseHeadPortrait {
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 50%;
  }

  .enterpriseMark {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 1rem;
    height: 1rem;
  }

  .enterpriseReleaseTime {
    font-size: 1.2rem;
    color: #C0C4CC;
  }

  .productCon {
    box-sizing: border-box;
    padding: 20px 15px;
    margin-top: 8px;
    background-color: #FFFFFF;
  }
  
  .productCon>>>.real-img{
    width: 100%;
  }

  .productCon>>>.urlMod {
    height: 82px;
    box-sizing: border-box;
    background-color: #F2F4F5;
    border-radius: 10px;
    padding: 12px;
    display: flex;
    margin: 10px 0;
    justify-content: space-between;
  }

  .productCon>>>.urlText {
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .productCon>>>.urlTitle {
    font-size: 14px;
    color: #1D2023;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .productCon>>>.urlUrl {
    font-size: 12px;
    color: #30ABFF;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .productCon>>>.urlUrl img {
    width: 1.2rem;
    height: 1.2rem;
  }

  .productCon>>>.urlIcon {
    width: 5.8rem;
    height: 5.8rem;
    background-color: #E8E9EB;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
  }

  .productCon>>>.urlIcon img {
    width: 3rem;
    height: 3rem;
  }

  .recommendedGoods {
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 1.6rem 1.5rem;
    margin-top: 1rem;
  }

  .recommendedTitle {
    font-size: 1.8rem;
    font-weight: 600;
    color: #1D2023;
  }

  .recommendedGoodsMod {
    display: flex;
    justify-content: space-between;
  }

  .recommendedGoodsList {
    position: relative;
    width: 48%;
    margin-top: 1.4rem;
  }
  
  .recommendedGoodsList:first-child {
    margin-right: 7px;
  }

  .recommendedGoodsImg {
    width: 100%;
    height: 16.7rem;
    object-fit: cover;
    border-radius: .5rem;
  }
  
  .callAppIcon{
    position: fixed;
    right: 0;
    bottom: 30%;
    z-index: 10;
  }
  
  .callAppIcon img{
    width: 7rem;
    height: 4.4rem;
  }
  
  .goodsTitlepro{
    font-weight: 400 !important;
    margin: 1px 0 5px 0;
  }
</style>
